export const TITLE = 'cart.title';
export const CONTINUE_SHOPPING = 'cart.continue_shopping';
export const START_SHOPPING = 'cart.start_shopping';
export const VIEW_ALL = 'cart.view_all';
export const SUGGESTED_PRODUCTS = 'cart.suggested_products';
export const SUGGESTED_PRODUCTS_EMPTY = 'cart.suggested_products_empty';
export const SUGGESTED_PRODUCTS_REWARDS = 'cart.suggested_products_rewards';
export const SHOP_NOW = 'cart.shop_now';
export const VIEW_ALL_PRODUCTS = 'cart.view_all_products';
export const NEED_HELP = 'cart.need_help';
export const CHANGE_SELECTION = 'cart.change_selection';
export const PRICE_EA = 'cart.price_ea';
